<script setup lang="ts">
import {watch, toRef, ref} from 'vue'
import SelectClaimType from '@/components/ui/select/SelectClaimType.vue';
import SelectCancellationNoticeType from '@/components/forms/SelectCancellationNoticeType.vue'
import Alert from '@/components/ui/alerts/Alert.vue'
import BaseInput from '@/components/ui/inputs/BaseInput.vue';
import SelectOffice from '../SelectOffice.vue';
import { ClaimsTypes } from '@/utils/config/constants/claims-types';

const props = defineProps(['claim', 'reservation', 'errors'])
const claim = toRef(props, 'claim')
const reservation = toRef(props, 'reservation')
const emit = defineEmits(['update:claim'])


watch(claim, claim => emit('update:claim', claim));
</script>

<template>
  <div class="grid grid-cols-1 text-left gap-x-8 gap-y-4 md:grid-cols-3">
    <div class="px-4 text-left sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Réservation & type de dossier</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600">Numéro de PNR et dossier (retard, annulation, etc).</p>
    </div>

    <form class="rounded-md shadow-sm bg-zinc-50 ring-1 ring-gray-900/5 md:col-span-2">
      <div class="px-4 py-6 sm:p-8">
        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-4">
            <div>
              <BaseInput v-model="reservation.pnrId" label="Numéro de réservation" placeholder="Numéro de PNR (Ex: R26B8I)" />
              <p v-if="errors.find(err => err.$property === 'pnrId')"
                 class="mt-1 text-sm text-left text-red-500">{{
                  errors.find(err => err.$property === 'pnrId')?.$message
                }}
              </p>
            </div>
            <div>
              <SelectOffice v-model="reservation.officeId" />
            </div>
          </div>
        </div>
        <div class="sm:col-span-4">
          <div class="mt-2">
            <span class="sm:max-w-md">
              <SelectClaimType @update:modelValue="selected => claim.claimType = selected.value" :default-selection="(ClaimsTypes[0] as any)" />
            </span>
            <div v-if="claim.claimType === 'FLIGHT_CANCELLATION'" class="mt-3">
              <SelectCancellationNoticeType  @update:modelValue="e => claim.cancellationNotice = e.value" />

              
            </div>

            <div v-if="claim.claimType === 'MISSED_CONNECTION_DUE_TO_DELAY'" class="pt-2">
              <Alert
                type="info"
                title="Information"
                message="Pour ce type de dossier, merci de nous indiquer le plus d’information possible dans les notes"
              />
            </div>
            
            <div v-if="claim.claimType === 'FLIGHT_DELAY'">
              <div class="relative flex items-start mt-3 text-left">
                <div class="flex items-center h-6">
                  <input id="comments" aria-describedby="comments-description" name="comments" type="checkbox"
                         v-model="claim.delayedTimeValid"
                         class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-600"/>
                </div>
                <div class="ml-3 text-sm leading-6">
                  <label for="comments" class="font-medium text-gray-900">Je confirme que le passager est arrivé avec au moins 3 heures de retard à destination finale</label>
                  <p id="comments-description" class="text-gray-500">
                    Ce qui compte c'est l'heure d'ouverture des portes, généralement 10 à 15 minutes après l'atterissage.
                  </p>
                </div>
              </div>
              <p v-if="errors.find(err => err.$property === 'delayedTimeValid')"
                 class="my-1 text-sm text-left text-red-500 ml-7">
                Veuillez confirmer le retard subi par le(s) passager(s)
              </p>
            </div>
            <p v-if="errors.find(err => err.$property === 'cancellationNotice')" class="my-1 text-sm text-left text-red-500">
              Merci de sélectionner le délai de notification de l'annulation
            </p>
            <p v-if="errors.find(err => err.$property === 'claimType')" class="mt-1 text-sm text-left text-red-500">
              {{ errors.find(err => err.$property === 'claimType')?.$message }}
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>